import { render, staticRenderFns } from "./PreparationMessage.vue?vue&type=template&id=052ab226&scoped=true&"
import script from "./PreparationMessage.vue?vue&type=script&lang=js&"
export * from "./PreparationMessage.vue?vue&type=script&lang=js&"
import style0 from "./PreparationMessage.vue?vue&type=style&index=0&id=052ab226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ab226",
  null
  
)

export default component.exports